import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  inject,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

const CONSENT_KEY = 'allindev-cookie-consent';

@Component({
  selector: 'app-cookie-consent',
  imports: [RouterLink, MatButtonModule],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentComponent {
  private readonly platformId = inject(PLATFORM_ID);

  readonly visible = signal(false);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const accepted = localStorage.getItem(CONSENT_KEY) === 'accepted';
      this.visible.set(!accepted);
    }
  }

  accept(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(CONSENT_KEY, 'accepted');
    }
    this.visible.set(false);
  }
}
